module.exports = __webpack_public_path__ + "img/plane.82247c6e.png";